module.exports = __webpack_public_path__ + "img/logo-7.21fe1891.png";